import _ from 'lodash';
import { CargoDetail } from '../consult';
import { FormControl } from '@angular/forms';
import { OnInit, Component, EventEmitter, Input, Output, ElementRef, ViewChild } from '@angular/core';
import * as SelectFX from 'periodicjs.component.selectfx';
declare var $:any;
import bigdecimal from 'bigdecimal';

@Component({
  selector: 'lcl-cargoinfo',
  templateUrl: 'lcl-cargoinfo.html',
})
export class LclCargoinfoComponent  {
  @Input() cargo;
  @Input() crncyList;
  @Output() delCargo = new EventEmitter();
  @Output() onChange = new EventEmitter();

  @ViewChild("commodityInput") commodityInput:ElementRef;

  showTooltip: boolean = false;
  
  ngOnInit() {
    
  }

  pkgUnitSelect(event) {
    this.cargo.pkgUnit = event;
  }

  volUnitChange(event) {
    this.cargo.volUnit = event;
    this.onChange.emit();
  }

  cargoweightChange(event) {
    let weight = event.target.value;
    this.cargo.weight = weight.replace(/[^0-9\.]/g, '');
    if (!this.cargo.wghtUnit) this.cargo.wghtUnit = 'kg'; // 08/23 중량 입력시 'kg'로 설정
    this.onChange.emit();
  }
  
  weightUnitChange(event) {
    this.cargo.wghtUnit = event;
    this.onChange.emit();
  }

  cargovalueChange(event) {
    let value = event.target.value;
    this.cargo.value = value.replace(/[^0-9\.]/g, '');
  }

  valueUnitChange(event) {
    this.cargo.valueUnit = event;
  }

  deleteCargo() {
    this.delCargo.emit(this.cargo);
  }

  handleChange() {
    this.onChange.emit();
  }

  focusShowTooltip() {
    this.showTooltip = true;
  }

  focusHideTooltip() {
    this.showTooltip = false;
  }

  setComodity(){
    this.cargo.commodity = this.commodityInput.nativeElement.value;
  }
  
}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/consult/consult-sub/lcl-cargoinfo.ts